import { LiveBar } from "./LiveBar";

/**
 * 4-Kriterien-Grid: Label (Mono Caps), LiveBar, Score "8.2 / 10" (Mono).
 * Default-Kriterien können überschrieben werden.
 */

export interface ScoreCriterion {
  label: string;
  /** 0..max */
  value: number;
}

interface ScoreBreakdownProps {
  criteria: ScoreCriterion[];
  max?: number;
  skin?: "presenter" | "light";
}

export const DEFAULT_CRITERIA_LABELS = [
  "INNOVATION",
  "WIRTSCHAFTLICH",
  "STRATEGIE",
  "UMSETZUNG",
] as const;

export function ScoreBreakdown({
  criteria,
  max = 10,
  skin,
}: ScoreBreakdownProps) {
  return (
    <div
      className="beacon-scorebreakdown"
      style={{
        display: "grid",
        gridTemplateColumns: "minmax(140px, auto) 1fr auto",
        columnGap: "var(--s-5)",
        rowGap: "var(--s-3)",
        alignItems: "center",
      }}
    >
      {criteria.map((c) => (
        <div key={c.label} style={{ display: "contents" }}>
          <span
            className="mono"
            style={{
              fontFamily: "var(--font-mono)",
              fontSize: 12,
              letterSpacing: "var(--tracking-meta)",
              textTransform: "uppercase",
              color:
                skin === "light"
                  ? "var(--paper-400)"
                  : "var(--ink-300)",
            }}
          >
            {c.label}
          </span>
          <LiveBar value={c.value} max={max} height={6} skin={skin} />
          <span
            className="mono"
            style={{
              fontFamily: "var(--font-mono)",
              fontVariantNumeric: "tabular-nums",
              fontSize: 14,
              fontWeight: 500,
              color:
                skin === "light"
                  ? "var(--paper-900)"
                  : "var(--svo-weiss, #fff)",
            }}
          >
            {c.value.toFixed(1)} / {max}
          </span>
        </div>
      ))}
    </div>
  );
}
